import { mdiChevronLeft } from "@mdi/js";
import Icon from "@mdi/react";
import { useSelector } from "react-redux";

import FactoringCompanySelect from "features/main/Loads/modules/FactoringCompanySelect";
import MainLayout from "layouts/Main";
import { selectOnboardingInformation } from "store/user/selector";
import styles from "./style.module.scss";
import { IFactoringCompany } from "models/HaulPay";

type SearchFactoringCompanyProps = {
  company?: IFactoringCompany;
  onCompanySelected: (company: IFactoringCompany) => void;
};

export default function SearchFactoringCompany({
  company,
  onCompanySelected
}: Readonly<SearchFactoringCompanyProps>) {
  const onboardingInformation = useSelector(selectOnboardingInformation);

  return (
    <MainLayout customHeader={<Icon path={mdiChevronLeft} className="w-8" />}>
      <div className={styles.searchFactoringCompany}>
        <FactoringCompanySelect
          factoring_id={onboardingInformation.factoring_id}
          company={company}
          onCompanySelected={onCompanySelected}
        />

        <div className="flex gap-2 text-sm justify-center mt-8">
          {"You didn't find the company?"}
          <button className="text-info underline underline-offset-2">Click here to add</button>
        </div>
      </div>
    </MainLayout>
  );
}
